import type { ChangePasswordFormCopy } from './models';
import { text as moduleText } from './text';
import { text as sharedText } from '@shared/text';

export const text = {
  changePasswordFormCopy(isSubmitting: boolean): ChangePasswordFormCopy {
    return {
      title: moduleText.title,
      subtitle: moduleText.subtitle,
      submitButtonLabel: isSubmitting ? sharedText.loading : moduleText.submit,
      currentPasswordLabel: moduleText.current,
      newPasswordLabel: moduleText.new,
      confirmPasswordLabel: moduleText.confirm,
      unavailableMessage: moduleText.unavailable,
    };
  },
};
